<template lang="jade">
  date-picker(v-if="fdata.editable && fdata.gui"
              dformat="D MMMM YYYY"
              ":label"="fdata.label"
              ":readonly"="!fdata.disabled"
              ":constraints"="constraints"
              ":year"="year"
              ":month"="month"
              ":value"="fdata.value"
              ":idx"="idx"
              ":name"="fdata.field")
  template(v-else)
    template(v-if="fdata.field === 'OUTPUT_FIELD'")
      div.Display.Display--input 
        strong.Display__label {{ fdata.label }}:
        span.Display__text {{{ fdata.value | format }}}
    template(v-else)  
      div.Input(":tooltip"="fdata.tip || false"
                v-bind:class="{'Input--filled': formInput, 'Input--invalid': error || externalErrors, 'Input--valid': complete }"
                ":skin"="skins.inputs")
        input.Input__field(":id"="fdata.id"
                          type="text"
                          @keydown="keyConstraint"
                          @keyup="mask"
                          ":name"="fdata.field"
                          @focus="attempts++"
                          @blur="validate"
                          placeholder="DD/MM/YYYY"
                          v-model="formInput"
                          ":disabled"="!fdata.editable"
                          ":required"="required")
        label.Input__label
          span.Input__label-content
            span.Input__icon
            {{ fdata.label }}
        div.Error(v-if="errors" class="animated" transition="fade") 
          p.Error__msg {{ errors }}
</template>

<script>
  import picker from './picker'
  import inputs from '../_shared/traits'
  import Moment from 'moment'
  import _ from 'lodash'

  export default {
    mixins: [inputs],
    data () {
      return {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        constraints: {},
        keymap: ['Enter', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'],
        formInput: '',
        uid: this.$parent.uid
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce: val => {
          return val.editable ? val : _.set(val, 'field', false)
        }
      }
    },
    components: {
      'date-picker': picker
    },
    methods: {
      mask (e) {
        e.preventDefault()
        if (_.includes(['Backspace', 'Delete'], e.key)) return true
        let mask = 'DD/MM/YYYY'
        let {value} = e.target
        let input = value.replace(/[-\/:\s]/g, '').split('').reduce((str, char, idx) => {
          if (mask.charAt(str.length) === '') return str // out of range
          // char is seperator
          if (/[-\/:\s]/.test(mask.charAt(str.length))) {
            str += mask.charAt(str.length)
          }

          if (/[0-9]/.test(char)) str += char

          if (/[-\/:\s]/.test(mask.charAt(str.length))) {
            str += mask.charAt(str.length)
          }

          return str
        }, '')
        e.target.value = input
      },
      keyConstraint (e) {
        let key = e.key
        if (_.includes(this.keymap, key)) return true
        if (e.ctrlKey || e.metaKey) return true
        return true
      },
      validate () {
        if (!this.validation) return this.dispatch()
        let date = _.isUndefined(this.formInput) || !_.isString(this.formInput) ? ''
                                                                                : this.formInput.split('/').reverse().join('/')
        let validated = this.computedValidate(this.fdata, date)
        this.fieldState(validated)
        if (this.config.inlineErrors && _.gt(this.attempts, 0)) {
          this.$set('errors', validated)
        }
        this.notice('error', validated)
      },
      dispatch () {
        if (this.fdata.field && this.fdata.editable) {
          let input = _.isUndefined(this.formInput) || !_.isString(this.formInput) ? '' : this.formInput.split('/').reverse().join('/')
          let date = Moment(input).format('D MMM YYYY')
          this.$dispatch('fdata::input',
                        {[this.fdata.field]: _.eq(date, 'Invalid date') ? '' : date},
                        this.idx)
        }
      }
    },
    ready () {
      let rules = this.fdata.validation.map(xs => xs.rule.split(':'))
      rules.forEach(xs => {
        switch (_.head(xs)) {
          case 'before_or_equal':
          case 'before':
            let date = new Date(_.last(xs))
            this.$set('year', date.getFullYear())
            this.$set('month', date.getMonth())
            this.$set('constraints.max', date)
            break
          case 'after_or_equal':
          case 'after':
            this.$set('constraints.min', new Date(_.last(xs)))
            break
        }
      })

      this.formInput = this.fdata.value

      if (!_.includes(['TypeMultipart'], this._context.constructor.name)) {
        let vuex = _.find(this.forms, ['uid', this.uid])
        if (vuex) {
          let formData = vuex.data[this.fdata.field]
          if (formData) {
            this.formInput = _.isArray(formData) ? formData[this.idx] : formData
          }
        }
      }
      if (this.validation) this.validate()
    }
  }
</script>



// WEBPACK FOOTER //
// date.vue?10f35a5a